import Vapi from 'vuex-rest-api';
import axios from '@/api/axios';

const store = new Vapi({
  axios,
  state: {
    plantsLp: [],
  },
})
  .get({
    action: 'getPlantsLp',
    property: 'plantsLp',
    path: () => 'plants-lp',
  })
  .getStore();

export default store;
